module.exports = __webpack_public_path__ + "img/header-memoireRingsExclusive.1e8207e.webp";